// ChatTab.tsx
import React, { useState, useRef, useEffect } from "react";
import { sendChat } from "../core/_request";
import ChatTypingLoader from "../../apps/components/ChatTypingLoader";

type Message = {
  text: string;
  sender: "user" | "ai";
  id: string;
};
const getDefaultMessage = (): Message => ({
  text: "Hi! I'm here to help you.",
  sender: "ai",
  id: crypto.randomUUID(),
});

const ChatTab: React.FC<{ stage_id: number; sub_stage_id: string, msgs: Message[] }> = ({ stage_id, sub_stage_id, msgs }) => {
  const [messages, setMessages] = useState<Message[]>(msgs);
  const [input, setInput] = useState("");
  const bottomRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState("");

  useEffect(() => {
    setMessages(msgs);

    setSessionId("");
  }, [stage_id, sub_stage_id]);

  // const sendMessage = async () => {
  //   try {
  //     if (!input.trim()) return;

  //     setInput("");
  //     setMessages((prev) => [...prev, { text: input, sender: "user", id: crypto.randomUUID() }]);
  //     setLoading(true);

  //     const res = await sendChat(sessionId,`stage_${stage_id}`, sub_stage_id, input.trim());

  //     if (res.success) {
  //       setMessages((prev) => [...prev, { text: res.data.reply, sender: "ai", id: crypto.randomUUID() }]);
  //       setSessionId(res.data.session_id);
  //     } else {
  //       console.error(res.message);
  //       setMessages((prev) => [
  //         ...prev,
  //         {
  //           text: res.message || "Unable to process request.",
  //           sender: "ai",
  //           id: crypto.randomUUID(),
  //         },
  //       ]);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         text: "Something went wrong. Please try again.",
  //         sender: "ai",
  //         id: crypto.randomUUID(),
  //       },
  //     ]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="d-flex flex-column h-100">
      <div className="chat-container p-0 mb-10">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`chat-bubble ${msg.sender === "user" ? "user" : "ai"
              }`}
          >
            {msg.text}
          </div>
        ))}
        <div ref={bottomRef} />
        {loading && <ChatTypingLoader />}
      </div>

      <div className="d-flex mt-2 chat-input ps-3 pe-3 pb-3">
        <input
          className="form-control form-control-sm me-2"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask anything..."
          disabled={loading}
        />
        <button className="btn btn-primary btn-sm" onClick={() => { }} disabled={loading}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatTab;